import { Component, OnInit, OnDestroy, ChangeDetectorRef, Inject, PLATFORM_ID, LOCALE_ID } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationService } from '../shared/navigation/navigation.service';
import { Observable, Subscription } from 'rxjs';
import { Settings } from '../shared/navigation/pages.model';
import { take } from 'rxjs/operators';
import { MAP_LOADED } from '../shared/shared.module';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { utils } from '../shared/helpers/utils';
import { AuthService } from '../shared/auth/auth.service';
/**
 * This class represents the lazy loaded ContactComponent.
 */
@Component({
  selector: 'app-contact',
  templateUrl: 'contact.component.html',
  styleUrls: ['contact.component.scss']
})
export class ContactComponent implements OnInit, OnDestroy {

 public pageTitle: string;
 public pageContent: string;
 public form: FormGroup;
 public res = 0;
 public loading = false;
 public sent = false;
 public regulations = false;
 public sub: Subscription;
 public settings: Settings = new Settings;
 public isBrowser = false;
 public withvin = false;
 public countries = utils.countries;
 //map
 public zoom = 12;
 public center = { lat: 51.23355520443756, lng: 22.70509916957845};
 public options = {};
 public infoContent = '';
 public subjects = [
  {value: 1, viewValue: $localize `:@@cntct_sub_1:Zakup przyczepy`},
  {value: 2, viewValue: $localize `:@@cntct_sub_2:Zakup części zamiennych`},
  {value: 3, viewValue: $localize `:@@cntct_sub_3:Prośba o dokumenty do przyczepy`},
  {value: 4, viewValue: $localize `:@@cntct_sub_4:Chcę zostać dealerem`},
  {value: 5, viewValue: $localize `:@@cntct_sub_5:Inne`}
 ]
 public path_dealers = '/';
 public isLogged = false;

 constructor(@Inject(PLATFORM_ID) private platformId: string,  @Inject(LOCALE_ID) public localeId: string, @Inject(MAP_LOADED) public mapLoaded$: Observable<boolean>, private router: Router, private route: ActivatedRoute, private navigationService: NavigationService, private authService: AuthService, public fb: FormBuilder, private cdr: ChangeDetectorRef) {
  if (isPlatformBrowser(this.platformId)) { 
    this.isBrowser = true;
  }
  this.path_dealers = this.router.config.find(x => x.data?.module === 'DistributorsModule')?.path || '/';
 }

 ngOnInit() {
  this.createForm();
  this.pageTitle = this.route.snapshot.data.name;
  this.navigationService.item(this.route.snapshot.data.id).pipe(take(1)).subscribe((result: any) => {
    this.pageContent = result.content;
    this.cdr.detectChanges();
  });
  this.sub = this.navigationService.navigation.subscribe(this.getSettings);

  this.authService.isLoggedIn.pipe(take(1)).subscribe(state => {
    this.isLogged = state.logged;
  });
 }

 getSettings = (menu: any) => {
  if (menu.menu.length) {
    // setTimeout(() => {
      this.settings = menu.settings;
    // }, 500);
  }
 }

 createForm() {

    let default_country = this.countries.find(c => c.value == this.localeId.toUpperCase())?.value || 'Polska';

    if (this.localeId != 'pl') {
      this.countries.sort(function(a, b) {
          return a.viewValue.localeCompare(b.viewValue);
      });
    }

    this.form = this.fb.group({
        namesurname: [''], //honeypot
        from: ['Wiadomość z podstrony kontaktu.'],
        email: ['', [Validators.required, Validators.email]],
        name: ['', Validators.required],
        country: [default_country, Validators.required],
        company: ['', Validators.required],
        postcode: ['', Validators.required],
        subject: ['', Validators.required],
        vin: [''],
        message: ['', Validators.required],
        rodo: ['', Validators.requiredTrue],
        newsletter: [''],

        utm_campaign: [this.route.snapshot.queryParamMap.get('utm_campaign')],
        utm_content: [this.route.snapshot.queryParamMap.get('utm_content')],
        utm_medium: [this.route.snapshot.queryParamMap.get('utm_medium')],
        utm_source: [this.route.snapshot.queryParamMap.get('utm_source')],
        utm_term: [this.route.snapshot.queryParamMap.get('utm_term')],

        form_name: ['Formularz kontakowy'],
        click: [this.navigationService.getClickId().value?.click]
    });

    this.form.controls.subject.valueChanges.subscribe(v => {
      if (+v == 2) {
        this.withvin = true;
        this.form.get('vin').setValidators([Validators.required]);
      } else {
        this.withvin = false;
        this.form.get('vin').setValidators([]);
      }
      this.cdr.detectChanges();
    });

  }

  submit() {
  if (this.form.status === 'VALID') {
  this.loading = true;
  const formModel = this.form.value;
  this.sub = this.navigationService.email(formModel).subscribe((result: any) => {
      this.res = result.message;
      this.loading = false;
      this.sent = true;
      if((<any>window).dataLayer) {
          (<any>window).dataLayer.push({
              event: 'form_submit',
              form_name: 'Contact',
          });
      }
      this.cdr.detectChanges();
    }, error => {
      this.res = 2;
      this.loading = false;
      this.cdr.detectChanges();
    }
  );
  } else {
  this.form.controls.rodo.markAsDirty();
  }
  }

 ngOnDestroy() {
   if (this.sub) {
     this.sub.unsubscribe();
   }
 }

}
